/**
 * Shared formatting helpers used across the analysis/holdings views.
 */

export function formatCurrency(value, { currency = 'GBP', locale = 'en-GB', digits = 0 } = {}) {
  if (value === undefined || value === null) return '-';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

export function formatPercent(value, digits = 2) {
  if (value === undefined || value === null || value === '' || value === 'Unknown') return '-';
  const n = Number(value);
  if (Number.isNaN(n)) return '-';
  return `${n.toFixed(digits)}%`;
}

export function formatProfitFactor(value, digits = 2) {
  if (value === undefined || value === null || value === '') return 'N/A';
  const n = Number(value);
  if (!Number.isFinite(n)) return 'N/A';
  return n.toFixed(digits);
}

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
